import React from 'react'

const DotsLoader = () => {
  return (
    <div className='ghaith--dots-loader'></div>
  )
}

export default DotsLoader